<!-- reservation-guest-modal.component.html -->
<div class="guest-modal">
    <div class="modal-header">
        <h2>Huéspedes Registrados</h2>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal-content">
        <div class="guests-container">
            <div class="guest-card" *ngFor="let guest of guests">
                <div class="guest-header">
                    <div class="guest-name-section">
                        <h3 class="guest-name">{{ guest.fullName }}</h3>
                        <span class="guest-id-type">{{ guest.documentType }}</span>
                    </div>
                </div>

                <div class="guest-details">
                    <div class="detail-row">
                        <div class="detail-item">
                            <span class="detail-label">Número de Documento</span>
                            <span class="detail-value">{{ guest.documentNumber }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">Celular</span>
                            <span class="detail-value">{{ guest.phone }}</span>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-item full-width">
                            <span class="detail-label">Email</span>
                            <span class="detail-value">{{ guest.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="empty-state" *ngIf="guests.length === 0">
                <mat-icon>person_off</mat-icon>
                <p>No hay huéspedes registrados para esta reserva</p>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <div class="total-guests">
            <span class="total-label">Total Huéspedes</span>
            <span class="total-value">{{ totalGuests }}</span>
        </div>
    </div>
</div>